/**
 * AP-10 · los modales que un nodo abre con createPortal (p. ej. «Editar
 * imagen») siguen dentro de su árbol React: sus eventos de hover/foco suben
 * hasta el disparador del tooltip y lo abrían o cerraban encima del modal.
 * Envuelve los handlers para reaccionar sólo a eventos ocurridos dentro del
 * nodo en el DOM.
 */
export function guardTriggerProps(props) {
  const out = {};
  Object.entries(props || {}).forEach(([k, fn]) => {
    out[k] = typeof fn === 'function' && /^on[A-Z]/.test(k)
      ? (e) => {
        const box = e?.currentTarget;
        const t = e?.target;
        if (box && typeof box.contains === 'function' && t && t.nodeType && !box.contains(t)) return undefined;
        return fn(e);
      }
      : fn;
  });
  return out;
}

export default guardTriggerProps;
